<template>
  <div class="modal" @click.self="close" :class="{ 'modal--Rtl': ['ar'].includes(this.$route.query.lang) }">
    <!-- --Ar -->
    <button @click="closeModal()" class="modal__Overlay"></button>
    <success-prompt :updated="updated" :message="prompt.success"></success-prompt>
    <transition name="fade">
      <div class="diffEditor" v-if="revisions.active">
        <header class="modal__Header">
          <h1 class="modal__Title">{{ $store.getters.getStringTranslation('compareRevisions') }}</h1>

          <div class="modal__Meta">
            <ul>
              <li class="modal__MetaItem--Button" v-if="revisions.selected">
                <button class="button--Small button--Alt" @click="useRevision">
                  {{ $store.getters.getStringTranslation('useThisRevision') }}
                </button>
              </li>
              <li class="modal__MetaItem">
                <button @click="closeRevisions" class="modal__MetaLink">
                  <icon name="times"></icon>
                </button>
              </li>
            </ul>
          </div>
        </header>
        <loader class="imageLoader" :loading="true" v-if="revisions.loading" />
        <div class="diffEditor__Empty" v-else-if="revisions.data.length === 0">
          <h2>{{ $store.getters.getStringTranslation('noRevisions') }}</h2>
          <p>
            {{ $store.getters.getStringTranslation('noRevisionsDesc') }}
          </p>
        </div>
        <div class="diffEditor__Inner" v-else>
          <div class="diffEditor__Viewer" v-if="revisions.selected">
            <code-diff-viewer
              :key="revisions.selected.id"
              :new-content="JSON.stringify(filterRevisionObject(revisions.selected), null, 2)"
              :old-content="JSON.stringify(filterRevisionObject(item), null, 2)"
              title="Compare revisions"
            />
          </div>
          <div class="diffEditor__Empty--Left" v-else>
            <h2>{{ $store.getters.getStringTranslation('selectDate') }}</h2>
            <p>
              {{ $store.getters.getStringTranslation('selectDateDesc') }}
            </p>
          </div>
          <ul class="diffEditor__List">
            <li
              :class="{ 'is-Active': revisions.selected && revisions.selected.id === revision.id }"
              v-for="(revision, index) in revisions.data"
              :key="`revision-${index}`"
            >
              <button @click="revisions.selected = revision">
                {{ moment(revision.updated_at).format('DD.MM.YYYY., HH:mm:ss') }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="subscribersList" v-if="subscribers.active && item.type === 'campaign'">
        <header class="modal__Header">
          <h1 class="modal__Title">{{ $store.getters.getStringTranslation('subscribers') }}</h1>
          <div class="modal__Meta">
            <ul>
              <!-- <li class="modal__MetaItem">
                <button class="button--Small button--Error">Disable newsletter</button>
              </li> -->
              <li class="modal__MetaItem">
                <button class="button--Small button--Alt" @click="getSubscribersCSV">
                  {{ $store.getters.getStringTranslation('downloadCSV') }}
                </button>
              </li>
              <li class="modal__MetaItem">
                <button @click="closeSubscribersList" class="modal__MetaLink">
                  <icon name="times"></icon>
                </button>
              </li>
            </ul>
          </div>
        </header>
        <div class="subscriber">
          <div class="listing">
            <section class="page">
              <div class="tab">
                <div class="tab__Wrapper">
                  <table class="postsTable">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>E-mail</th>
                        <th>Status</th>
                        <th>Subscribed</th>
                      </tr>
                    </thead>
                    <tbody>
                      <subscriber
                        v-for="subscriber in subscribers.list"
                        :key="subscriber.id"
                        :subscriber="subscriber"
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </transition>
    <div class="modal__Inner--Builder">
      <header class="modal__Header">
        <h1 class="modal__Title">
          {{ $store.getters.getStringTranslation($route.name.replace(/\s/g, '').toLowerCase()) || $route.name
          }}<template v-if="l10n[lang].title"
            >: <span>{{ l10n[lang].title }}</span></template
          >
        </h1>

        <div class="modal__Meta">
          <ul>
            <li class="modal__MetaItem--Button" v-if="$route.params.id && previewLinks.length > 0">
              <span class="button--Small button--AccentThree"
                >{{ $store.getters.getStringTranslation('preview') }}
                <ul>
                  <li v-for="(website, index) in previewLinks" :key="`website-preview-${index}`">
                    <a
                      :href="`${website.url}/${previewLinkBase(website)}/${slugify(l10n[lang].title)}?lang=${lang}&id=${
                        $route.params.id
                      }&showLogin=true`"
                      target="_blank"
                      >{{ website.url.replace('https://', '').replace('http://', '') }}</a
                    >
                  </li>
                </ul>
              </span>
            </li>
            <li class="modal__MetaItem--Button" v-if="$route.params.id">
              <button @click="clone()" :disabled="disableUpdate" class="button--Small button--Accent">
                {{ $store.getters.getStringTranslation('duplicate') }}
              </button>
            </li>
            <li class="modal__MetaItem--Button">
              <button
                @click="
                  setLastUser()
                  update()
                "
                :disabled="disableUpdate"
                class="button--Small"
              >
                {{ prompt.save }}
              </button>
            </li>
            <li class="modal__MetaItem--Button" v-if="item.status === 'draft'">
              <button
                @click="
                  item.status = 'published'
                  update()
                "
                :disabled="updated === true"
                class="button--Small"
              >
                {{ $store.getters.getStringTranslation('publish') }}
              </button>
            </li>
            <li class="modal__MetaItem">
              <button @click="closeModal()" class="modal__MetaLink">
                <icon name="times"></icon>
              </button>
            </li>
          </ul>
        </div>
      </header>

      <div class="modal__Scrollable" id="editorModal">
        <div class="modal__BuilderWrapper">
          <section class="modal__Editor--Builder">
            <error-prompt class="error--Modal" :errors="errors"></error-prompt>

            <p>
              <label class="formLabel" for="editTitle">{{ $store.getters.getStringTranslation('title') }}</label>
              <input v-model="l10n[lang].title" required type="text" class="formInput" id="editTitle" />
            </p>
            <p v-if="['event', 'gdoa_event', 'campaign', 'case_study', 'project'].includes(item.type)">
              <label class="formLabel" for="editLocation">{{ $store.getters.getStringTranslation('location') }}</label>
              <gmap-autocomplete
                class="formInput"
                :value="l10n[lang].location_info"
                @place_changed="setPlace"
              ></gmap-autocomplete>
            </p>
            <p v-if="item.type === 'campaign'">
              <label class="formLabel" for="editHashtag">{{
                $store.getters.getStringTranslation('campaignHashtag')
              }}</label>
              <input v-model="item.contents.additionals.hashtag" type="text" class="formInput" id="editHashtag" />
              <span class="note">{{ $store.getters.getStringTranslation('campaignHashtagDesc') }}</span>
            </p>
            <p v-if="item.type === 'event'">
              <input
                class="formCheckbox__Checkbox"
                type="checkbox"
                name="virtual"
                id="virtual"
                v-model="item.contents.additionals.virtual"
              />
              <label class="formCheckbox__Label--Short" for="virtual">Virtual event</label>
            </p>
            <div class="form__Row" v-if="item.type === 'event'">
              <!-- workon -->
              <div class="form__Column">
                <label class="formLabel" for="editHashtag">
                  {{ $store.getters.getStringTranslation('startTime') }}
                </label>
                <timepicker
                  class="form__TimePicker"
                  format="HH:mm"
                  v-model="item.contents.additionals.startTime"
                  :minute-interval="5"
                ></timepicker>
              </div>
              <div class="form__Column">
                <label class="formLabel" for="editHashtag">{{ $store.getters.getStringTranslation('endTime') }} </label>
                <timepicker
                  class="form__TimePicker"
                  format="HH:mm"
                  v-model="item.contents.additionals.endTime"
                  :minute-interval="5"
                ></timepicker>
              </div>
              <div class="form__Column">
                <label class="formLabel" for="editHashtag">{{ $store.getters.getStringTranslation('timezone') }}</label>
                <select class="formSelect" v-model="item.contents.additionals.timezone" required>
                  <option value="" selected>
                    {{ $store.getters.getStringTranslation('select') }}
                    {{ $store.getters.getStringTranslation('timezone') }}
                  </option>
                  <option
                    v-for="timezone in timezones"
                    :value="timezone.Abbreviation"
                    :key="timezone.id"
                    :title="timezone.DisplayName"
                  >
                    {{ timezone.Abbreviation }} - {{ timezone.DisplayName }}
                  </option>
                </select>
              </div>
            </div>
            <p v-if="item.start_datetime !== undefined">
              <label class="formLabel" for="editDate"
                ><template v-if="scraperData.type === 'event' || ['case_study', 'project'].includes(item.type)">{{
                  $store.getters.getStringTranslation('startDate')
                }}</template
                ><template v-else>{{ $store.getters.getStringTranslation('date') }}</template></label
              >
              <datepicker
                :format="formatDate"
                v-model="item.start_datetime"
                class="formInput--Date"
                id="editDate"
              ></datepicker>
            </p>
            <p v-if="['event', 'gdoa_event', 'campaign', 'project', 'case_study'].includes(item.type)">
              <label class="formLabel" for="editEndDate">{{ $store.getters.getStringTranslation('endDate') }}</label>
              <datepicker
                :format="formatDate"
                v-model="item.end_datetime"
                class="formInput--Date"
                id="editEndDate"
              ></datepicker>
            </p>
            <p v-if="enabled === true || enabled.general_options.subtitle">
              <label class="formLabel" for="editSubtitle">{{ $store.getters.getStringTranslation('subtitle') }}</label>
              <input required type="text" class="formInput" v-model="l10n[lang].subtitle" id="editSubtitle" />
            </p>
            <p v-if="enabled === true || enabled.general_options.foreword">
              <label class="formLabel" for="editForeword">{{ $store.getters.getStringTranslation('foreword') }}</label>
              <text-editor v-model="l10n[lang].foreword" />
            </p>
            <p>
              <label class="formLabel" for="editDescription">{{
                $store.getters.getStringTranslation('description')
              }}</label>
              <textarea
                id="editDescription"
                required
                class="formInput--Textarea"
                v-model="l10n[lang].description"
              ></textarea>
            </p>

            <p v-if="types.includes('video') || types.includes('audio')">
              <select class="formSelect" v-model="item.type">
                <option value="">Choose type</option>
                <option :value="item" v-for="item in types" :key="item.id">
                  {{ item.charAt(0).toUpperCase() + item.slice(1) }}
                </option>
              </select>
            </p>

            <p
              v-if="
                l10n[lang].external_url !== undefined &&
                !['page', 'blog', 'digital_publication', 'clause'].includes(item.type)
              "
            >
              <label class="formLabel" for="editURL">URL</label>
              <span class="formSection__Columns--Editor">
                <!-- If type equals 'event', change v-model to source.name -->
                <input
                  v-if="scraperData.type === 'event' && l10n[lang].source !== undefined && l10n[lang].source !== null"
                  required
                  v-model="l10n[lang].source.url"
                  type="url"
                  class="formInput--Scrape"
                  id="editURL"
                />
                <input
                  v-else
                  required
                  v-model="l10n[lang].external_url"
                  type="url"
                  class="formInput--Scrape"
                  id="editURL"
                />
                <button
                  type="button"
                  @click="scrape()"
                  :disabled="scrappable"
                  class="button--Scrape"
                  v-if="this.scraperData.type !== 'document'"
                >
                  {{ $store.getters.getStringTranslation('scrape') }}
                  <template v-if="scraperData.type === 'event'">{{
                    $store.getters.getStringTranslation('event')
                  }}</template>
                  <template v-else>{{ $store.getters.getStringTranslation(scraperData.type) }}</template>
                </button>
                <file-upload
                  v-if="['document', 'media'].includes(this.scraperData.type)"
                  :required="true"
                  v-model="l10n[lang].external_url"
                  :types="this.scraperData.type === 'media' ? ['audio', 'video'] : ['pdf', 'doc', 'xls', 'ppt']"
                ></file-upload>
              </span>
            </p>

            <p v-if="scraperData.type === 'document'" class="note">
              {{ $store.getters.getStringTranslation('ifDocOnline') }}
            </p>

            <!-- Check if pasted URL has assigned the item.type from it's extension -->
            <p
              v-if="
                scraperData.type === 'document' &&
                item.type &&
                ['doc', 'pdf', 'ppt', 'xls', 'docx', 'pptx'].indexOf(item.type) === -1
              "
              class="note--Important"
            >
              {{ $store.getters.getStringTranslation('ifDocOnlineError') }}
            </p>

            <!-- Check if pasted URL has assigned the item.type from it's extension -->
            <p
              v-if="
                scraperData.type === 'document' &&
                item.type &&
                ['doc', 'pdf', 'ppt', 'xls', 'docx', 'pptx'].indexOf(item.type) === -1
              "
              class="note--Important"
            >
              {{ $store.getters.getStringTranslation('multimediaError') }}
            </p>

            <template v-if="item.type === 'clause' && item.contents.additionals.clause_properties">
              <div class="formSection__Row--Gray formSection__Row--Gap">
                <h2 class="formTitle">Clause properties</h2>
                <p
                  v-for="prop in [
                    'class',
                    'class_full',
                    'id',
                    'internal_id',
                    'year',
                    'original_language',
                    'external_union',
                  ]"
                  :key="`clause-prop-${prop}`"
                >
                  <label class="formLabel" :for="`edit-clause-property-${prop}`">{{ capitalize(prop) }}</label>
                  <input
                    type="text"
                    :id="`edit-clause-property-${prop}`"
                    class="formInput"
                    v-model="item.contents.additionals.clause_properties[prop]"
                  />
                </p>
              </div>
            </template>

            <template v-for="taxonomy in filteredTaxonomies">
              <div
                class="formSection__Row--ChildTags"
                :key="taxonomy.id"
                v-if="enabled === true || enabled.tags[taxonomy.name]"
              >
                <search-child-tags
                  v-if="loading === false && ['sector', 'issue', 'organisation'].includes(taxonomy.name) && action"
                  class="formSearchWrapper--ChildTags"
                  :showLabel="false"
                  :label="`Choose ${taxonomy.name}`"
                  :types="[taxonomy.name]"
                  :lang="lang"
                  :placeholder="`Choose ${taxonomy.name}`"
                  :icon="taxonomy.icon"
                  :tags="item.tags.filter((tag) => tag.type === taxonomy.name)"
                  v-model="taxonomy.data"
                  @onchange="
                    syncTags()
                    setAffiliateActive(taxonomy.name)
                  "
                  :defaultTags="taxonomy.name === 'organisation' ? 1131 : null"
                  :action="actionStatus()"
                  :user="user"
                />
                <!-- Hide search tag when creating campaign beacause campaign tag dosnt exists at this moment -->
                <search-tag
                  v-else-if="loading === false && taxonomy.name === 'type'"
                  class="formSearchWrapper--Tags"
                  :showLabel="false"
                  :types="[taxonomy.name]"
                  :lang="lang"
                  :placeholder="`Choose ${taxonomy.name}`"
                  :icon="taxonomy.icon"
                  :tags="item.tags.filter((tag) => tag.type === taxonomy.name)"
                  v-model="taxonomy.data"
                  @onchange="syncTags"
                />
                <search-tag
                  v-else-if="loading === false && ['country', 'region'].includes(taxonomy.name)"
                  class="formSearchWrapper--Tags"
                  :showLabel="false"
                  :types="[taxonomy.name]"
                  :lang="lang"
                  :placeholder="`Choose ${taxonomy.name}`"
                  :icon="taxonomy.icon"
                  :tags="item.tags.filter((tag) => tag.type === taxonomy.name)"
                  v-model="taxonomy.data"
                  @onchange="syncTags"
                  @handleParentTag="setParentTag"
                  :countryParentTag="taxonomy.name === 'region' ? countryParentTag : null"
                />
                <search-child-tags
                  v-else-if="
                    loading === false &&
                    taxonomy.name === 'campaign' &&
                    ((action === 'update' && item.type === 'campaign') || item.type !== 'campaign')
                  "
                  class="formSearchWrapper--ChildTags formSearchWrapper--Campaigns"
                  :showLabel="false"
                  :label="`Choose ${taxonomy.name}`"
                  :types="[taxonomy.name]"
                  :lang="lang"
                  :placeholder="`Choose ${taxonomy.name}`"
                  :icon="taxonomy.icon"
                  :tags="item.tags.filter((tag) => tag.type === taxonomy.name)"
                  v-model="taxonomy.data"
                  @onchange="syncTags"
                />
                <search-tag
                  v-else-if="loading === false"
                  class="formSearchWrapper--Tags"
                  :showLabel="false"
                  :types="[taxonomy.name]"
                  :lang="lang"
                  :placeholder="`Choose ${taxonomy.name}`"
                  :icon="taxonomy.icon"
                  :tags="item.tags.filter((tag) => tag.type === taxonomy.name)"
                  v-model="taxonomy.data"
                  @onchange="syncTags"
                />
              </div>
            </template>

            <nav>
              <ul class="modal__BuilderChangeEditor--Type">
                <li>
                  <button @click="layout = 'builder'" :class="{ 'is-active': layout === 'builder' }">
                    {{ $store.getters.getStringTranslation('layoutBuilder') }}
                    <span>{{ l10n[lang].contents.length }}</span>
                  </button>
                </li>
                <li v-if="enabled === true || enabled.general_options.custom_fields">
                  <button @click="layout = 'fields'" :class="{ 'is-active': layout === 'fields' }">
                    {{ $store.getters.getStringTranslation('customFields') }}
                    <span v-if="l10n[lang].custom_fields">{{ l10n[lang].custom_fields.length }}</span>
                  </button>
                </li>
              </ul>
            </nav>

            <section class="modal__Builder" v-if="layout === 'fields'">
              <nav class="modal__Add">
                <span class="modal__AddIcon">
                  <icon name="plus" weight="regular"></icon>
                </span>

                <ul class="modal__AddList">
                  <li>
                    <button @click="addCustomField('string')">
                      {{ $store.getters.getStringTranslation('stringField') }} <icon name="font"></icon>
                    </button>
                  </li>
                  <li>
                    <button @click="addCustomField('text')">
                      {{ $store.getters.getStringTranslation('editorField') }} <icon name="pen"></icon>
                    </button>
                  </li>
                  <li>
                    <button @click="addCustomField('repeater')">
                      {{ $store.getters.getStringTranslation('repeaterField') }} <icon name="repeat"></icon>
                    </button>
                  </li>
                  <li>
                    <button @click="addCustomField('tags')">
                      {{ $store.getters.getStringTranslation('tagsField') }} <icon name="tags"></icon>
                    </button>
                  </li>
                  <li>
                    <button @click="addCustomField('author')">
                      {{ $store.getters.getStringTranslation('authorField') }} <icon name="user"></icon>
                    </button>
                  </li>
                  <li>
                    <button @click="addCustomField('image')">
                      {{ $store.getters.getStringTranslation('imageField') }} <icon name="image"></icon>
                    </button>
                  </li>
                </ul>
              </nav>

              <p>
                <label for="text-field-search" class="formLabel"
                  >{{ $store.getters.getStringTranslation('searchFieldByName') }}
                </label>
                <input type="text" class="formInput" id="text-field-search" v-model="fieldSearch" />
              </p>

              <p v-if="customFieldGroups">
                <label for="custom-field-select-group" class="formLabel">{{
                  $store.getters.getStringTranslation('showGroup')
                }}</label>
                <select class="formSelect" id="custom-field-select-group" v-model="showFieldGroup">
                  <option :value="null">{{ $store.getters.getStringTranslation('all') }}</option>
                  <option v-for="(group, index) in customFieldGroups" :value="group" :key="`group-option-${index}`">
                    {{ capitalize(group) }}
                  </option>
                </select>
              </p>

              <div class="modal__BuilderBlock" v-for="(block, index) in customFields" :key="block.id">
                <!-- Custom field options (remove, delete) -->
                <ul class="modal__BuilderOptions">
                  <li class="modal__BuilderOptionsItem--Title" v-if="block.type">
                    id:
                    <template v-if="block.name">
                      <span class="modal__BuilderOptionsItemTitle" @dblclick="renameField = index">{{
                        block.name
                      }}</span></template
                    >
                  </li>
                  <li class="modal__BuilderOptionsItem--Delete">
                    <button class="modal__BuilderButton" @click="removeCustomField(index)">
                      <icon name="trash-alt"></icon>
                      <span>{{ $store.getters.getStringTranslation('removeField') }}</span>
                    </button>
                  </li>
                </ul>

                <div class="modal__BuilderBlockWrapper">
                  <div class="modal__BuilderBlockOptions" v-if="renameField === index || block.name.length === 0">
                    <p>
                      <label :for="`text-field-name-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('fieldName')
                      }}</label>
                      <input
                        type="text"
                        class="formInput"
                        :id="`text-field-name-${index}`"
                        @focus="renameField = index"
                        v-model="block.name"
                      />
                    </p>
                    <p>
                      <label :for="`field-group-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('groupName')
                      }}</label>
                      <input type="text" class="formInput" :id="`field-group-${index}`" v-model="block.group" />
                    </p>
                  </div>

                  <!-- WYSIWYG editor -->
                  <template v-if="block.type === 'text'">
                    <text-editor v-model="block.text" />
                  </template>

                  <!-- String field -->
                  <template v-else-if="block.type === 'string'">
                    <p>
                      <label :for="`string-field-value-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('value')
                      }}</label>
                      <textarea class="formInput" :id="`string-field-value-${index}`" v-model="block.text"></textarea>
                    </p>
                  </template>

                  <!-- Repeater -->
                  <!-- TODO: Create reusable components of all builder blocks -->
                  <template v-else-if="block.type === 'repeater'">
                    <div v-for="n in parseInt(block.length)" :key="n.id">
                      <div v-for="(repeater, index) in block.contents" :key="repeater.id">
                        <!-- Custom field options (remove, delete) -->
                        <ul class="modal__BuilderOptions">
                          <li class="modal__BuilderOptionsItem--Title" v-if="block.type">
                            {{ formatBlockTitle(repeater.type)
                            }}<template v-if="repeater.name">: {{ repeater.name }}</template>
                          </li>
                          <li class="modal__BuilderOptionsItem--Delete">
                            <button class="modal__BuilderButton" @click="removeCustomField(index, block.contents)">
                              <icon name="trash-alt"></icon>
                              <span>{{ $store.getters.getStringTranslation('removeField') }}</span>
                            </button>
                          </li>
                        </ul>

                        <!-- Repeater WYSIWYG editor -->
                        <template v-if="repeater.type === 'text'">
                          <div class="modal__BuilderBlockWrapper--Repeater">
                            <p>
                              <label :for="`text-repeater-field-name-${index}`" class="formLabel">{{
                                $store.getters.getStringTranslation('fieldName')
                              }}</label>
                              <input
                                type="text"
                                class="formInput"
                                :id="`text-field-name-${index}`"
                                v-model="repeater.name"
                              />
                            </p>
                            <text-editor v-model="repeater.text" />
                          </div>
                        </template>

                        <!-- Repeater string field -->
                        <template v-else-if="repeater.type === 'string'">
                          <div class="modal__BuilderBlockWrapper--Repeater">
                            <p>
                              <label :for="`string-field-name-${index}`" class="formLabel">{{
                                $store.getters.getStringTranslation('fieldName')
                              }}</label>
                              <input
                                type="text"
                                class="formInput"
                                :id="`string-field-name-${index}`"
                                v-model="repeater.name"
                              />
                            </p>
                            <p>
                              <label :for="`string-field-value-${index}`" class="formLabel">{{
                                $store.getters.getStringTranslation('value')
                              }}</label>
                              <textarea
                                class="formInput"
                                :id="`string-field-value-${index}`"
                                v-model="repeater.text"
                              ></textarea>
                            </p>
                          </div>
                        </template>

                        <!-- Repeater resource field -->
                        <template v-else-if="repeater.type === 'resource'">
                          <div class="modal__BuilderBlockWrapper--Repeater">
                            <p>
                              <label :for="`string-field-name-${index}`" class="formLabel">{{
                                $store.getters.getStringTranslation('fieldName')
                              }}</label>
                              <input
                                type="text"
                                class="formInput"
                                :id="`string-field-name-${index}`"
                                v-model="repeater.name"
                              />
                            </p>
                            <p>
                              <label :for="`string-field-value-${index}`" class="formLabel">{{
                                $store.getters.getStringTranslation('value')
                              }}</label>
                              <search-resource
                                :key="`string-field-resource-${index}`"
                                :lang="lang"
                                :resources="repeater.resource_id"
                                :apiKeys="item.api_keys"
                                v-model="repeater.resource_id"
                              />
                            </p>
                          </div>
                        </template>
                      </div>
                    </div>

                    <nav class="modal__Add--Repeater">
                      <span class="button">{{ $store.getters.getStringTranslation('addField') }}</span>

                      <ul class="modal__AddList">
                        <li>
                          <button @click="addCustomField('string', block.contents)">
                            {{ $store.getters.getStringTranslation('stringField') }} <icon name="font"></icon>
                          </button>
                        </li>
                        <li>
                          <button @click="addCustomField('text', block.contents)">
                            {{ $store.getters.getStringTranslation('editorField') }} <icon name="pen"></icon>
                          </button>
                        </li>
                        <li>
                          <button @click="addCustomField('resource', block.contents)">
                            {{ $store.getters.getStringTranslation('resourceField') }} <icon name="file-alt"></icon>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </template>

                  <!-- Tags field -->
                  <template v-else-if="block.type === 'tags'">
                    <p>
                      <search-tag
                        :types="['issue', 'sector', 'organisation', 'country', 'region', 'type']"
                        :lang="lang"
                        :tags="block.tag_ids"
                        v-model="block.tag_ids"
                        :placeholder="$store.getters.getStringTranslation(searchTags)"
                      />
                    </p>
                  </template>

                  <!-- Authors field -->
                  <template v-else-if="block.type === 'author' && isAdmin">
                    <p>
                      <search-author :lang="lang" :authors="block.authors" v-model="block.authors" />
                    </p>
                  </template>

                  <!-- Image field -->
                  <template v-else-if="block.type === 'image'">
                    <p>
                      <image-upload :required="true" v-model="block.images"></image-upload>
                    </p>
                  </template>
                </div>
              </div>

              <div class="modal__BuilderHelper">
                <p>
                  <icon name="align-left" /><br />
                  {{ $store.getters.getStringTranslation('usePlus') }}
                </p>
                <div class="modal__BuilderButtons--Copy">
                  <template v-for="translation in langs">
                    <button
                      class="button--Accent"
                      :key="translation.id"
                      v-if="
                        l10n[translation.toLowerCase()] !== undefined &&
                        l10n[translation.toLowerCase()].custom_fields &&
                        l10n[translation.toLowerCase()].custom_fields.length > 0 &&
                        translation.toLowerCase() !== lang
                      "
                      @click="copyBlocks(translation, 'custom_fields')"
                    >
                      <icon name="sign-in" weight="solid" /> {{ $store.getters.getStringTranslation('overwriteFrom') }}
                      {{ translation }}
                    </button>
                  </template>
                </div>
              </div>
            </section>

            <section class="modal__Builder" v-else>
              <nav class="modal__Add">
                <span class="modal__AddIcon">
                  <icon name="plus" weight="regular"></icon>
                </span>

                <ul class="modal__AddList">
                  <li>
                    <button @click="addText()">
                      {{ $store.getters.getStringTranslation('blockOfText') }} <icon name="pen"></icon>
                    </button>
                  </li>
                  <li>
                    <button @click="addAccordion()">
                      {{ $store.getters.getStringTranslation('accordion') }} <icon name="caret-down"></icon>
                    </button>
                  </li>
                  <li v-if="enabled === true || enabled.blocks.image_block">
                    <button @click="addImage()">
                      {{ $store.getters.getStringTranslation('imageBlock') }} <icon name="image"></icon>
                    </button>
                  </li>
                  <li v-if="enabled === true || enabled.blocks.image_quote">
                    <button @click="addImageQuote()">
                      {{ $store.getters.getStringTranslation('imageQuote') }} <icon name="quote-right"></icon>
                    </button>
                  </li>
                  <li v-if="enabled === true || enabled.blocks.video_block">
                    <button @click="addVideo()">
                      {{ $store.getters.getStringTranslation('videoBlock') }} <icon name="video"></icon>
                    </button>
                  </li>
                  <li v-if="enabled === true || enabled.blocks.resources_block">
                    <button @click="addResource()">
                      {{ $store.getters.getStringTranslation('readMoreResources') }} <icon name="file-alt"></icon>
                    </button>
                  </li>
                  <li v-if="enabled === true || enabled.blocks.related_resources_block">
                    <button @click="addRelatedResources()">
                      {{ $store.getters.getStringTranslation('readMoreTags') }} <icon name="file-alt"></icon>
                    </button>
                  </li>
                  <li v-if="item.type === 'campaign' && (enabled === true || enabled.blocks.petition_block)">
                    <button @click="addPetition()">
                      {{ $store.getters.getStringTranslation('addPetition') }} <icon name="address-card"></icon>
                    </button>
                  </li>
                  <li v-if="item.type === 'campaign' && (enabled === true || enabled.blocks.event_block)">
                    <button @click="addEvent()">
                      {{ $store.getters.getStringTranslation('addEvent') }} <icon name="calendar-alt"></icon>
                    </button>
                  </li>
                  <li v-if="isAdmin && (enabled === true || enabled.blocks.attachments)">
                    <button @click="addRepo()">
                      {{ $store.getters.getStringTranslation('attachments') }} <icon name="lock"></icon>
                    </button>
                  </li>
                  <li v-if="enabled === true || enabled.blocks.quiz_embed">
                    <button @click="addQuizEmbed()">Quiz <icon name="question"></icon></button>
                  </li>
                  <li>
                    <button @click="addVideoask()">Videoask <icon name="lock"></icon></button>
                  </li>
                  <li>
                    <button @click="addAnchor()">Anchor <icon name="hashtag"></icon></button>
                  </li>
                  <li
                    v-for="website in websites.filter(
                      (site) =>
                        item.api_keys.includes(site.api_key) &&
                        site.additionals.website_blocks &&
                        site.additionals.website_blocks.length > 0
                    )"
                    class="modal__AddListWebsite"
                    :key="website.id"
                  >
                    <h3>{{ website.url.replace('http://', '').replace('https://', '') }}</h3>
                    <ul>
                      <li v-for="block in website.additionals.website_blocks" :key="block.id">
                        <button @click="addWebsiteBlock(block, website.additionals.website_blocks)">
                          {{
                            $store.getters.getStringTranslation(block.name.replace(/_/g, ' ').replace(/\s/g, '')) ||
                            formatBlockTitle(block.name)
                          }}
                        </button>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>

              <!-- <p>
                <label for="text-block-search" class="formLabel">Search block by title</label>
                <input type="text" class="formInput" id="text-block-search" v-model="blockSearch">
              </p> -->

              <div
                class="modal__BuilderBlock"
                v-for="(block, index) in blocks"
                :key="`builder-block-${index}`"
                :class="{ 'is-Highlighted': activeIndex === index }"
              >
                <!-- Block options (remove, delete) -->
                <ul class="modal__BuilderOptions">
                  <li class="modal__BuilderOptionsItem--Title" v-if="block.name">
                    {{ `${index + 1}: ${formatBlockTitle(block.name)}` }}
                  </li>
                  <li class="modal__BuilderOptionsItem--Title" v-else-if="block.type">
                    {{ `${index + 1}: ${formatBlockTitle(block.type)}` }}
                  </li>
                  <li class="modal__BuilderOptionsItem--Delete">
                    <button class="modal__BuilderButton" @click="removeBlock(index)">
                      <icon name="trash-alt"></icon>
                      <span>{{ $store.getters.getStringTranslation('removeBlock') }}</span>
                    </button>
                  </li>
                  <li class="modal__BuilderOptionsItem--Duplicate">
                    <button class="modal__BuilderButton" @click="duplicateBlock(index)">
                      <icon name="clone"></icon>
                      <span>{{ $store.getters.getStringTranslation('duplicateBlock') }}</span>
                    </button>
                  </li>
                  <li class="modal__BuilderOptionsItem--Exchange">
                    <button class="modal__BuilderButton" @click="movePrompt(index)">
                      <icon name="sort-numeric-down"></icon>
                      <span>{{ $store.getters.getStringTranslation('moveItem') }}</span>
                    </button>
                  </li>
                  <li class="modal__BuilderOptionsItem">
                    <button class="modal__BuilderButton" @click="moveBlock(index, index - 1)">
                      <icon name="arrow-up"></icon> <span>{{ $store.getters.getStringTranslation('oneUp') }}</span>
                    </button>
                  </li>
                  <li class="modal__BuilderOptionsItem">
                    <button class="modal__BuilderButton" @click="moveBlock(index, index + 1)">
                      <icon name="arrow-down"></icon> <span>{{ $store.getters.getStringTranslation('oneDown') }} </span>
                    </button>
                  </li>
                </ul>

                <!-- Website block -->
                <template v-if="block.type === 'website_block'">
                  <template v-if="block.name === 'clause_theme'">
                    <search-tag
                      :types="['clause_theme']"
                      :lang="lang"
                      :showLabel="false"
                      :tags="block.contents.tag_ids"
                      v-model="block.contents.tag_ids"
                      placeholder="Search tags"
                    />
                  </template>
                  <website-block v-model="block.contents" :contents="block.contents" :lang="lang" v-else />
                </template>

                <!-- WYSIWYG editor -->
                <template v-if="block.type === 'text'">
                  <text-editor v-model="block.text" />
                </template>

                <!-- Video -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'video'">
                  <search-resource
                    :key="`resource-block-video-search-${block.blockID ? block.blockID : blocks.length}`"
                    :types="['video']"
                    :lang="lang"
                    :multiple="false"
                    :resources="block.video ? [block.video] : []"
                    @change="updateResources(block, $event, 'video')"
                    :apiKeys="item.api_keys"
                    v-model="block.id"
                  />
                </div>

                <!-- Related resource -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'related_resources'">
                  <p>
                    <label :for="`related-title-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('blockTitle')
                    }}</label>
                    <input type="text" class="formInput" :id="`related-title-${index}`" v-model="block.title" />
                  </p>
                  <p>
                    <label :for="`related-type-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('type')
                    }}</label>
                    <select class="formSelect" :id="`related-type-${index}`" v-model="block.types[0]">
                      <option v-for="type in contentTypes" :value="type" :key="type.id">
                        {{ capitalize(type) }}
                      </option>
                    </select>
                  </p>
                  <p>
                    <label :for="`related-limit-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('limit')
                    }}</label>
                    <input type="number" class="formInput" :id="`related-limit-${index}`" v-model="block.limit" />
                    <span class="note">{{ $store.getters.getStringTranslation('limitDisplayedResources') }}</span>
                  </p>

                  <search-tag
                    :types="['issue', 'sector', 'organisation', 'country', 'region', 'type']"
                    :lang="lang"
                    :tags="block.tag_ids"
                    v-model="block.tag_ids"
                    placeholder="Search tags"
                  />
                </div>

                <!-- Image -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'image'">
                  <p>
                    <label :for="`image-text-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('text')
                    }}</label>
                    <textarea
                      class="formInput formInput--Text"
                      :id="`image-text-${index}`"
                      v-model="block.text"
                    ></textarea>
                  </p>
                  <p>
                    <label :for="`image-caption-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('caption')
                    }}</label>
                    <input type="text" class="formInput" :id="`image-caption-${index}`" v-model="block.caption" />
                  </p>
                  <p>
                    <label :for="`image-caption-url-${index}`" class="formLabel"
                      >{{ $store.getters.getStringTranslation('caption') }} URL</label
                    >
                    <input
                      type="text"
                      class="formInput"
                      :id="`image-caption-url-${index}`"
                      v-model="block.caption_url"
                    />
                  </p>
                  <p>
                    <label :for="`image-alt-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('alt')
                    }}</label>
                    <input type="text" class="formInput" :id="`image-alt-${index}`" v-model="block.alt" />
                  </p>
                  <p>
                    <image-upload :required="true" v-model="block.thumbnail_urls"></image-upload>
                  </p>
                </div>

                <!-- Image quote -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'quote'">
                  <div
                    class="modal__BuilderQuote"
                    :style="`background-image: url(${
                      block.thumbnail_urls ? block.thumbnail_urls.large : block.thumbnail_url
                    })`"
                    v-if="block.text.length > 0"
                  >
                    <p class="modal__BuilderQuoteTitle">{{ block.text }}</p>
                    <p class="modal__BuilderQuoteSource">{{ block.source }}</p>
                  </div>

                  <p>
                    <label :for="`quote-text-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('text')
                    }}</label>
                    <textarea class="formInput" :id="`quote-text-${index}`" v-model="block.text"></textarea>
                  </p>
                  <p>
                    <label :for="`quote-title-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('title')
                    }}</label>
                    <input
                      type="text"
                      class="formInput formInput--Title"
                      :id="`quote-title-${index}`"
                      v-model="block.title"
                    />
                    <span class="note">{{ $store.getters.getStringTranslation('optionalDisplay') }}</span>
                  </p>
                  <p>
                    <label :for="`quote-role-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('role')
                    }}</label>
                    <input
                      type="text"
                      class="formInput formInput--Role"
                      :id="`quote-role-${index}`"
                      v-model="block.role"
                    />
                    <span class="note"> {{ $store.getters.getStringTranslation('optionalPersonPosition') }}</span>
                  </p>
                  <p>
                    <label :for="`quote-source-${index}`" class="formLabel">{{
                      $store.getters.getStringTranslation('author')
                    }}</label>
                    <input type="text" class="formInput" :id="`quote-source-${index}`" v-model="block.source" />
                  </p>
                  <p>
                    <image-upload :required="true" v-model="block.thumbnail_urls"></image-upload>
                  </p>
                </div>

                <!-- Resource -->
                <div class="modal__BuilderBlockWrapper" v-if="block.type === 'resources'">
                  <p>
                    <label class="formLabel" :for="`resource-block-title-${index}`">{{
                      $store.getters.getStringTranslation('blockTitle')
                    }}</label>
                    <input :id="`resource-block-title-${index}`" class="formInput" type="text" v-model="block.title" />
                  </p>
                  <search-resource
                    :key="`resource-block-search-${block.blockID ? block.blockID : blocks.length}`"
                    :lang="lang"
                    :resources="block.resources"
                    @change="updateResources(block, $event)"
                    :apiKeys="item.api_keys"
                    v-model="block.ids"
                    :status="item.status"
                  />
                </div>

                <!-- Quiz embed -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'quiz_embed'">
                  <p>
                    <search-resource
                      :key="`quiz-embed-${block.blockID ? block.blockID : blocks.length}`"
                      :multiple="false"
                      :lang="lang"
                      :types="['quiz']"
                      :resources="block.resources"
                      :fetchResources="true"
                      :quizId="block.id ? [block.id] : []"
                      @change="updateResources(block, $event)"
                      :apiKeys="item.api_keys"
                      v-model="block.id"
                    />
                  </p>
                </div>

                <!-- Repository -->
                <repository
                  v-if="block.type === 'repository'"
                  :block="block"
                  :apiKeys="item.api_keys"
                  :status="item.status"
                />

                <!-- CTA: petition -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'cta_petition'">
                  <template>
                    <!-- <p>
                      <label :for="`new-cta-label-${index}`" class="formLabel">Name</label>
                      <input type="text" class="formInput" :id="`new-cta-label-${index}`" v-model="block.params.name" />
                    </p> -->

                    <p>
                      <label :for="`new-cta-title-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('title')
                      }}</label>
                      <input type="text" class="formInput" :id="`new-cta-name-${index}`" v-model="block.title" />
                    </p>

                    <!-- <p>
                      <label :for="`new-cta-result-${index}`" class="formLabel">Goal</label>
                      <input type="number" class="formInput" :id="`new-cta-result-${index}`" v-model="block.params.contents.goal" />
                    </p> -->

                    <p>
                      <label :for="`new-cta-result-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('result')
                      }}</label>
                      <input type="text" class="formInput" :id="`new-cta-result-${index}`" v-model="block.result" />
                    </p>
                    <p class="note">{{ $store.getters.getStringTranslation('userKnowAchieve') }}</p>

                    <p>
                      <label :for="`new-cta-show-signatures-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('showSignatures')
                      }}</label>
                      <select
                        class="formSelect"
                        :id="`new-cta-show-signatures-${index}`"
                        v-model="block.show_signatures"
                      >
                        <option value="confirmed">
                          {{ $store.getters.getStringTranslation('showSignaturesConfirmed') }}
                        </option>
                        <option value="all">{{ $store.getters.getStringTranslation('showSignaturesAll') }}</option>
                        <option value="hide">{{ $store.getters.getStringTranslation('hideSignatures') }}</option>
                      </select>
                    </p>

                    <loader class="imageLoader" :loading="signatures.loading" />

                    <div v-if="signatures[block.id]" class="modal__BuilderSignatures">
                      <button
                        class="modal__BuilderSignaturesTitle"
                        @click="signatures.collapsed[block.id] = !signatures.collapsed[block.id]"
                      >
                        {{ $store.getters.getStringTranslation('signatures') }}
                        <icon
                          class="modal__BuilderSignaturesChevron"
                          name="chevron-up"
                          :class="{ 'is-Active': setSignaturesCollapsed(block.id) }"
                        ></icon>
                      </button>

                      <table
                        class="modal__BuilderSignaturesTable"
                        :class="{ 'is-Collapsed': signatures.collapsed[block.id] }"
                      >
                        <tr>
                          <th>{{ $store.getters.getStringTranslation('signee') }}</th>
                          <th>{{ $store.getters.getStringTranslation('email') }}</th>
                          <th>{{ $store.getters.getStringTranslation('country') }}</th>
                          <th>{{ $store.getters.getStringTranslation('occupation') }}</th>
                          <th>{{ $store.getters.getStringTranslation('orgRole') }}</th>
                          <!-- <th>Is confirmed</th> -->
                          <th>{{ $store.getters.getStringTranslation('isOrg') }}</th>
                          <th>{{ $store.getters.getStringTranslation('isAnonym') }}</th>
                        </tr>
                        <tr v-for="signature in signatures[block.id]" :key="signature.id">
                          <td>
                            {{ signature.name }}
                          </td>
                          <td>
                            {{ signature.email }}
                          </td>
                          <td>
                            <template v-if="signature.country">{{
                              filterByProp(signature.country.l10n, 'lang', lang, 'en').name
                            }}</template>
                          </td>
                          <td>
                            {{ signature.organisation }}
                          </td>
                          <td>
                            {{ signature.organisation_role }}
                          </td>
                          <!-- <td>
                            {{ signature.is_confirmed }}
                          </td> -->
                          <td>
                            {{ signature.is_organisation }}
                          </td>
                          <td>
                            {{ signature.is_anonymouse }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="modal__BuilderButtons">
                      <button @click="showSignatures(block.id)" class="button" v-if="!signatures[block.id]">
                        {{ $store.getters.getStringTranslation('showSignaturesAll') }}
                      </button>
                      <button @click="exportSignatures(block.id, 'csv')" class="button">
                        {{ $store.getters.getStringTranslation('exportCSV') }}
                      </button>
                    </div>
                  </template>
                </div>

                <!-- CTA: event -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'cta_event'">
                  <template v-if="block.id">
                    <p>
                      <label :for="`new-cta-label-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('label')
                      }}</label>
                      <input type="text" class="formInput" :id="`new-cta-label-${index}`" v-model="block.label" />
                    </p>
                    <p>
                      <label :for="`cta-title-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('title')
                      }}</label>
                      <input disabled type="text" class="formInput" :id="`cta-title-${index}`" :value="block.title" />
                    </p>
                    <p>
                      <label :for="`cta-event-name-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('eventName')
                      }}</label>
                      <input
                        disabled
                        type="text"
                        class="formInput"
                        :id="`cta-event-name-${index}`"
                        :value="getTranslation(block.event.l10n)"
                      />
                    </p>
                    <p>
                      <label :for="`cta-id-${index}`" class="formLabel">CTA ID</label>
                      <input disabled type="number" class="formInput" :id="`cta-id-${index}`" :value="block.id" />
                    </p>
                  </template>
                  <template v-else-if="block.params && block.params.name !== undefined">
                    <p>
                      <label :for="`new-cta-name-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('nameInternal')
                      }}</label>
                      <input type="text" class="formInput" :id="`new-cta-name-${index}`" v-model="block.params.name" />
                    </p>
                    <p class="note">{{ $store.getters.getStringTranslation('nameInternalDesc') }}</p>

                    <p>
                      <label :for="`new-cta-label-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('label')
                      }}</label>
                      <input type="text" class="formInput" :id="`new-cta-label-${index}`" v-model="block.label" />
                    </p>

                    <p>
                      <label :for="`new-cta-title-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('title')
                      }}</label>
                      <input type="text" class="formInput" :id="`new-cta-name-${index}`" v-model="block.title" />
                    </p>

                    <p>
                      <label :for="`new-cta-result-${index}`" class="formLabel">{{
                        $store.getters.getStringTranslation('result')
                      }}</label>
                      <input type="text" class="formInput" :id="`new-cta-result-${index}`" v-model="block.result" />
                    </p>
                    <p class="note">{{ $store.getters.getStringTranslation('userKnowAchieve') }}</p>

                    <p>
                      <search-resource
                        :types="['event', 'gdoa_event']"
                        :lang="lang"
                        :multiple="false"
                        :resources="block.event ? [block.event] : []"
                        :apiKeys="item.api_keys"
                        v-model="block.params.contents.event_id"
                      />
                    </p>
                  </template>
                </div>

                <!-- accordion -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'accordion'">
                  <div
                    class="accordion modal__BuilderBlockWrapper"
                    v-for="(item, index) in block.accordions"
                    :key="index"
                  >
                    <ul class="modal__BuilderOptions">
                      <li class="modal__BuilderOptionsItem--Title" v-if="block.type">Item {{ index + 1 }}</li>
                      <li class="modal__BuilderOptionsItem--Delete">
                        <button class="modal__BuilderButton" @click="removeAccordionItem(block, index)">
                          <icon name="trash-alt"></icon>
                          <span>{{ $store.getters.getStringTranslation('removeField') }}</span>
                        </button>
                      </li>
                      <li class="modal__BuilderOptionsItem">
                        <button
                          class="modal__BuilderButton"
                          @click="moveAccordionBlock(index, 'up', block.accordions)"
                          :disabled="index === 0"
                        >
                          <icon name="arrow-up"></icon> <span>{{ $store.getters.getStringTranslation('oneUp') }}</span>
                        </button>
                      </li>
                      <li class="modal__BuilderOptionsItem">
                        <button
                          class="modal__BuilderButton"
                          @click="moveAccordionBlock(index, 'down', block.accordions)"
                          :disabled="index === block.accordions.length - 1"
                        >
                          <icon name="arrow-down"></icon>
                          <span>{{ $store.getters.getStringTranslation('oneDown') }} </span>
                        </button>
                      </li>
                    </ul>
                    <div class="accordion__Content">
                      <template v-if="!item.type">
                        <p>
                          <label :for="`quote-text-${index}`" class="formLabel">{{
                            $store.getters.getStringTranslation('title')
                          }}</label>
                          <input class="formInput" :id="`quote-text-${index}`" v-model="item.title" />
                        </p>
                        <p>
                          <label :for="`quote-text-${index}`" class="formLabel">{{
                            $store.getters.getStringTranslation('content')
                          }}</label>
                          <text-editor v-model="item.content" />
                        </p>
                      </template>
                      <template v-if="item.type === 'resource'">
                        <div class="modal__BuilderBlockWrapper">
                          <p>
                            <label class="formLabel" :for="`resource-block-title-${index}`">{{
                              $store.getters.getStringTranslation('blockTitle')
                            }}</label>
                            <input
                              :id="`resource-block-title-${index}`"
                              class="formInput"
                              type="text"
                              v-model="item.title"
                            />
                          </p>
                          <search-resource
                            :key="`resource-block-search-${item.blockID ? item.blockID : item.length}`"
                            :lang="lang"
                            :resources="item.resources"
                            @change="updateResources(item, $event)"
                            :apiKeys="item.api_keys"
                            v-model="item.ids"
                            :status="item.status"
                          />
                        </div>
                      </template>
                    </div>
                  </div>
                  <p>
                    <button class="button" @click="addAccordionItem(block)">
                      {{ $store.getters.getStringTranslation('addBlock') }}
                    </button>
                  </p>
                  <p>
                    <button class="button" @click="addAccordionItemRepo(block)">Add repository</button>
                  </p>
                </div>

                <!-- videoask -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'cta_videoask'">
                  <div class="videoaskBuildingBlock">
                    <ul class="videoaskBuildingBlock__Steps">
                      <li>Follow link to videoask page.</li>
                      <li>Record your video.</li>
                      <li>Paste url in field below.</li>
                    </ul>
                    <a
                      href="https://app.videoask.com/app/organizations/570b9b8e-8fb5-46d0-8e44-1d3771c6de51/all-interactions"
                      target="_blank"
                      class="button"
                      >Record your support</a
                    >
                  </div>
                  <div class="accordion__Content">
                    <p>
                      <label class="formLabel">Title</label>
                      <input type="text" class="formInput" v-model="block.title" />
                    </p>
                    <p>
                      <label class="formLabel">Url</label>
                      <input type="text" class="formInput" v-model="block.url" />
                    </p>

                    <div class="videoaskIframeBox" v-if="block.url">
                      <iframe
                        :src="block.url"
                        allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
                        width="100%"
                        height="600px"
                        style="border: none; border-radius: 24px"
                      >
                      </iframe>
                    </div>

                    <!-- <iframe
                      src="https://www.videoask.com/fimtdttmk"
                      allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
                      width="100%"
                      height="600px"
                      style="border: none; border-radius: 24px"
                    >
                    </iframe> -->
                  </div>
                </div>

                <!-- anchor -->
                <div class="modal__BuilderBlockWrapper" v-else-if="block.type === 'anchor_link'">
                  <p>
                    <label class="formLabel formLabel--Anchor">
                      <template v-if="block.url">
                        <span v-if="validateAnchor(block.url)" class="valid">Anchor is valid.</span>
                        <span v-else class="inValid">Anchor is invalid. Use plain text without spaces or symbols.</span>
                      </template>
                      <template v-else> Anchor </template>
                    </label>
                    <input type="text" class="formInput" v-model="block.url" />
                  </p>
                  <ul v-if="block.url" class="anchorLinkTexts">
                    <li v-if="validateAnchor(block.url)">
                      Please copy the output, including the '#' symbol, and paste it into the desired link.
                    </li>
                    <li v-if="validateAnchor(block.url)">
                      <strong>#{{ block.url }}</strong>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="modal__BuilderHelper">
                <p>
                  <icon name="th-large" /><br />
                  {{ $store.getters.getStringTranslation('usePlus') }}
                </p>
                <template v-if="Object.keys(l10n).length > 1">
                  <div class="modal__BuilderButtons--Copy">
                    <p>{{ $store.getters.getStringTranslation('overwriteFrom') }}:</p>
                    <template v-for="translation in langs">
                      <button
                        class="button--Accent"
                        :key="translation.id"
                        v-if="
                          l10n[translation.toLowerCase()] !== undefined &&
                          l10n[translation.toLowerCase()].contents &&
                          l10n[translation.toLowerCase()].contents.length > 0 &&
                          translation.toLowerCase() !== lang
                        "
                        @click="copyBlocks(translation, 'contents')"
                      >
                        <icon name="sign-in" weight="solid" />
                        {{ translation }}
                      </button>
                    </template>
                  </div>
                  <div class="modal__BuilderButtons--Copy">
                    <p>Translate with DeepL:</p>
                    <template v-for="translation in langs">
                      <button
                        class="button--Accent"
                        @click="fetchDeeplTranslation(translation)"
                        :key="translation.id"
                        v-if="
                          l10n[translation.toLowerCase()] !== undefined &&
                          l10n[translation.toLowerCase()].contents &&
                          l10n[translation.toLowerCase()].contents.length > 0 &&
                          translation.toLowerCase() !== lang
                        "
                      >
                        <icon name="globe" weight="solid" /> {{ translation }}
                      </button>
                    </template>
                  </div>
                </template>
              </div>
            </section>
          </section>

          <aside class="modal__Post--Sidebar">
            <loader class="imageLoader" :loading="loading || updating" />
            <template v-if="loading === false">
              <div class="cardPreview">
                <div class="cardPreview__Columns--Block">
                  <div class="cardPreview__Column">
                    <h2 class="cardPreview__Title">{{ $store.getters.getStringTranslation('languages') }}</h2>
                    <ul class="cardPreview__Meta">
                      <li v-for="(translation, index) in langs" :key="translation.id">
                        <!-- Regular link for exising translation -->
                        <template v-if="l10n[translation.toLowerCase()] !== undefined">
                          <router-link
                            class="cardPreview__MetaLink"
                            :title="langLabels[index].label"
                            :to="translationURL(translation)"
                            >{{ translation }}
                            <icon name="check" v-if="l10n[translation.toLowerCase()].title.length > 0"></icon>
                          </router-link>

                          <button
                            v-if="item.l10n.length > 1"
                            class="cardPreview__MetaPopup"
                            @click="removeTranslation(translation)"
                          >
                            <icon name="times"></icon> {{ $store.getters.getStringTranslation('remove') }}
                          </button>
                        </template>

                        <!-- New translation -->
                        <button
                          class="cardPreview__MetaLink--Add"
                          @click="addTranslation(translation)"
                          :title="langLabels[index].label"
                          v-else
                        >
                          {{ translation }}
                          <icon name="plus" weight="solid"></icon>
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div class="cardPreview__Column">
                    <h2 class="cardPreview__Title">{{ $store.getters.getStringTranslation('controls') }}</h2>
                    <ul class="cardPreview__Meta">
                      <li v-if="$route.params.id !== undefined">
                        <button class="cardPreview__MetaButton" @click="disable()">
                          <icon name="eye-slash"></icon> {{ disableLabel }}
                        </button>
                      </li>
                      <li>
                        <button class="cardPreview__MetaButton" @click="feature()">
                          <icon v-if="item.is_featured === false" name="star"></icon>
                          <icon v-else name="star" weight="solid"></icon>
                          {{ $store.getters.getStringTranslation('feature') }}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div
                class="formSection__Row"
                v-if="item.contents.additionals.contributor || item.contents.additionals.contributor_email"
              >
                <p v-if="item.contents.additionals.contributor">
                  <label class="formLabel" for="contributor">UNCSW Contributor</label>
                  <input
                    required
                    type="text"
                    class="formInput"
                    v-model="item.contents.additionals.contributor"
                    id="contributor"
                    placeholder="tag1, tag2, tag3"
                  />
                </p>

                <p v-if="item.contents.additionals.contributor_email">
                  <label class="formLabel" for="contributor_email">UNCSW Contributor email</label>
                  <input
                    required
                    type="text"
                    class="formInput"
                    v-model="item.contents.additionals.contributor_email"
                    id="contributor_email"
                    placeholder="tag1, tag2, tag3"
                  />
                </p>
              </div>

              <div class="formSection__Row" v-if="action !== 'create' && item.type === 'campaign'">
                <h2 class="cardPreview__Title">{{ $store.getters.getStringTranslation('subscribers') }}</h2>
                <button @click="getSubscribersList" class="button--Brand">
                  {{ $store.getters.getStringTranslation('showAll') }}
                </button>
              </div>

              <div class="formSection__Row">
                <p v-if="(enabled === true || enabled.general_options.parent) && item.type === 'page'">
                  <search-resource
                    :types="['page']"
                    :label="$store.getters.getStringTranslation('parentPage')"
                    :multiple="false"
                    :lang="lang"
                    :resources="item.parent"
                    v-model="item.parent_id"
                  />
                </p>

                <p>
                  <search-author
                    :label="$store.getters.getStringTranslation('postAuthor')"
                    :required="true"
                    :multiple="true"
                    :lang="lang"
                    :authors="item.authors"
                    v-model="item.authors_id"
                  />
                </p>

                <p>
                  <label class="formLabel"
                    >{{ $store.getters.getStringTranslation('language') }}
                    {{ $store.getters.getStringTranslation('status') }}</label
                  >
                  <select class="formSelect" v-model="l10n[lang].status">
                    <option v-for="status in languageStatuses" :value="status" :key="status.id">
                      {{ $store.getters.getStringTranslation(status.replace(/\s/g, '').toLowerCase()) }}
                    </option>
                  </select>
                </p>

                <p>
                  <!-- TODO: pass status field -->
                  <label class="formLabel"
                    >{{ $store.getters.getStringTranslation('post') }}
                    {{ $store.getters.getStringTranslation('status') }}</label
                  >
                  <select class="formSelect" v-model="item.status">
                    <option v-for="status in statuses" :value="status" :key="status.id">
                      {{ $store.getters.getStringTranslation(status.replace(/\s/g, '').toLowerCase()) }}
                    </option>
                  </select>
                </p>

                <div v-if="item.status === 'password_protected'" class="formRow--Password">
                  <form autocomplete="off" v-if="passwordChangeActive" @keydown.enter.prevent="onEnter">
                    <label class="formLabel">{{ $store.getters.getStringTranslation('postPassword') }}</label>
                    <input
                      required
                      type="text"
                      class="formInput formInput--Password"
                      v-model="item.password"
                      id="password"
                      placeholder="Set new password"
                    />
                    <!-- <span class="formLabel__PasswordStatus note" @click="show_password = !show_password">
                      <template v-if="!show_password">Hide</template>
                      <template v-else>Show</template>
                    </span> -->
                  </form>
                  <div v-else>
                    <div class="button--Brand" @click="passwordChangeActive = true">
                      {{ $store.getters.getStringTranslation('setPass') }}
                    </div>
                  </div>
                </div>

                <p>
                  <label class="formLabel">{{ $store.getters.getStringTranslation('postHistory') }}</label>
                  <button @click="getRevisions" class="button--Brand">
                    {{ $store.getters.getStringTranslation('manageRevisions') }}
                  </button>
                </p>
              </div>

              <div class="formSection__Row">
                <label class="formLabel">{{ $store.getters.getStringTranslation('postFlags') }}</label>
                <p v-for="flag in flags" :key="flag">
                  <input
                    class="formCheckbox__Checkbox"
                    type="checkbox"
                    name="post-flag"
                    :id="`post-flag-${flag}`"
                    :value="flag"
                    v-model="item.contents.additionals.post_flags"
                  />
                  <label class="formCheckbox__Label--Short" :for="`post-flag-${flag}`">{{
                    capitalize(flag.replace('_', ' '))
                  }}</label>
                </p>

                <template v-if="item.type === 'page'">
                  <input
                    class="formCheckbox__Checkbox"
                    type="checkbox"
                    name="post-flag"
                    id="hide-submenu"
                    :value="true"
                    v-model="item.contents.additionals.hide_submenu"
                  />
                  <label class="formCheckbox__Label--Short" for="hide-submenu">Hide resources submenu</label>
                </template>
              </div>

              <div class="formSection__Row">
                <label class="formLabel">{{ $store.getters.getStringTranslation('pageTemplates') }}</label>
                <p v-for="template in pageTemplates" :key="template">
                  <input
                    class="formCheckbox__Checkbox"
                    type="checkbox"
                    name="page-template"
                    :id="`page-template-${template}`"
                    :key="`page-template-${template}`"
                    :value="template"
                    v-model="item.contents.additionals.page_templates"
                  />
                  <label class="formCheckbox__Label--Short" :for="`page-template-${template}`">{{
                    capitalize(template.replace('_', ' '))
                  }}</label>
                </p>
              </div>

              <div class="formSection__Row">
                <label class="formLabel">{{ $store.getters.getStringTranslation('publishTo') }}</label>

                <p v-for="(website, index) in websites" :key="`website-api-key-${index}`">
                  <input
                    class="formCheckbox__Checkbox"
                    type="checkbox"
                    name="publish-website-to"
                    :id="`publish-website-${index}`"
                    :value="website.api_key"
                    v-model="item.api_keys"
                  />
                  <label class="formCheckbox__Label--Short" :for="`publish-website-${index}`">{{
                    website.url.replace('https://www.', '').replace('http://www.', '')
                  }}</label>
                </p>
              </div>

              <div class="formSection">
                <div class="formSection__Row">
                  <image-upload
                    :required="true"
                    class="formImage--Builder"
                    v-model="item.contents.thumbnail_urls"
                    inputClass="formImage__Input--Builder"
                    wrapperClass="formImage__Wrapper--Block"
                    @removeImage="removeThumbURL"
                  ></image-upload>
                  <p>
                    <label for="photoCredit" class="formLabel">{{
                      $store.getters.getStringTranslation('photoCredit')
                    }}</label>
                    <input
                      id="photoCredit"
                      v-model="photoCredits"
                      type="text"
                      class="formInput formInput--PhotoCredit"
                      :placeholder="$store.getters.getStringTranslation('enterPhotoCredit')"
                    />
                  </p>
                  <p>
                    <label for="photoCredit" class="formLabel">{{
                      $store.getters.getStringTranslation('photoCreditUrl')
                    }}</label>
                    <input
                      id="photoCredit"
                      v-model="photoCreditsUrl"
                      type="text"
                      class="formInput formInput--PhotoCredit"
                      :placeholder="$store.getters.getStringTranslation('photoCreditUrlDesc')"
                    />
                  </p>
                  <p>
                    <label for="order" class="formLabel">
                      {{ $store.getters.getStringTranslation('order') }}
                    </label>
                    <input
                      id="order"
                      v-model.number="item.contents.additionals.order"
                      type="number"
                      class="formInput"
                      placeholder="e.g. 1, 2, 100"
                    />
                  </p>
                  <p>
                    <label for="color" class="formLabel">{{ $store.getters.getStringTranslation('color') }}</label>
                    <span class="formSection__Columns--Editor">
                      <input
                        id="color"
                        v-model="item.contents.additionals.color"
                        type="color"
                        class="formInput formInput--Color"
                      />
                      <button class="button--Text" @click="item.contents.additionals.color = ''">Remove color</button>
                    </span>
                  </p>
                </div>
              </div>

              <template v-if="item.contents.additionals.last_edited_user">
                <div class="formSection" v-if="item.contents.additionals.last_edited_user.length > 0">
                  <div class="formSection__Row">
                    <p>
                      <label class="formLabel">Last edited<br /> </label>
                      <span
                        v-for="edit in item.contents.additionals.last_edited_user"
                        :key="edit.id"
                        class="lastEditedBy"
                        >{{ edit.name }} - {{ moment(edit.date).format('DD.MM.YY. HH:mm') }}</span
                      >
                    </p>
                  </div>
                </div>
              </template>
            </template>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/http-common.js'
import EditorDefaults from '@/components/mixins/EditorDefaults.js'
import TimeZones from '@/components/mixins/TimeZones.js'
import Slugify from '@/components/mixins/Slugify.js'
import HandleImageAdded from '@/components/mixins/HandleImageAdded.js'
import WebsiteBlock from '@/components/editor/blocks/WebsiteBlock.vue'
import SearchResource from '@/components/editor/blocks/SearchResource.vue'
import SearchAuthor from '@/components/editor/blocks/SearchAuthor.vue'
import Repository from '@/components/editor/blocks/Repository.vue'
import TextEditor from '@/components/editor/TextEditor.vue'
import SearchChildTags from '@/components/editor/blocks/SearchChildTags.vue'
import Subscriber from '@/components/listing/Subscriber.vue'

export default {
  mixins: [EditorDefaults, Slugify, HandleImageAdded, TimeZones],
  components: {
    WebsiteBlock,
    SearchResource,
    SearchAuthor,
    Repository,
    TextEditor,
    SearchChildTags,
    Subscriber,
  },
  data() {
    return {
      passwordChangeActive: false,
      countryParentTag: null,
      loadingResources: false,
      layout: 'builder',
      signatures: {
        loading: false,
        collapsed: {},
      },
      revisions: {
        active: false,
        selected: null,
        loading: false,
        data: null,
        error: null,
      },
      subscribers: {
        active: false,
        list: [],
      },
      fieldSearch: '',
      renameField: null,
      showFieldGroup: null,
      blockSearch: '',
      activeIndex: null,
      noResults: false,
      events: [],
      images: [],
      library: false,
      show_password: false,
    }
  },
  computed: {
    photoCredits: {
      get() {
        if (this.item.l10n.find((item) => item.lang === this.lang).photo_credits) {
          return this.item.l10n.find((item) => item.lang === this.lang).photo_credits
        } else {
          return this.item.l10n[0].photo_credits
        }
      },
      set(value) {
        this.item.l10n.find((item) => item.lang === this.lang).photo_credits = value
      },
    },
    photoCreditsUrl: {
      get() {
        if (this.item.l10n.find((item) => item.lang === this.lang).photo_credits_url) {
          return this.item.l10n.find((item) => item.lang === this.lang).photo_credits_url
        } else {
          return this.item.l10n[0].photo_credits_url
        }
      },
      set(value) {
        this.item.l10n.find((item) => item.lang === this.lang).photo_credits_url = value
      },
    },
    user() {
      return this.$store.state.accounts.user
    },
    isAdmin() {
      return this.user.is_admin || this.user.is_org_admin
    },
    contentTypes() {
      return this.$store.state.types.default
    },
    org() {
      return this.$store.state.accounts.org
    },
    customFieldGroups() {
      const groups = this.l10n[this.lang].custom_fields.map((field) => field.group)
      if (!groups.includes(undefined) && groups.length > 0)
        return groups.filter((v, i) => groups.indexOf(v) === i && v.length > 0)
      return null
    },
    customFields() {
      // Search through fields first, if group selection equals null show all items
      const fields = this.l10n[this.lang].custom_fields.filter((field) => field.name.includes(this.fieldSearch))
      if (this.showFieldGroup) return fields.filter((field) => field.group === this.showFieldGroup)
      return fields
    },
    blocks() {
      // Search through blocks
      const blocks = this.l10n[this.lang].contents
      return blocks
    },
    languageStatuses() {
      return this.statuses.filter((status) => status !== 'password_protected' && status !== 'unlisted')
    },
    createRevision() {
      if (
        (this.revisions.selected &&
          JSON.stringify(this.filterRevisionObject(this.item)) !==
            JSON.stringify(this.filterRevisionObject(this.revisions.selected))) ||
        (!this.revisions.selected && this.changed)
      )
        return true
      return false
    },
    action() {
      if (this.$route.params.id !== undefined) {
        return 'update'
      }

      return 'create'
    },
  },
  mounted() {
    if (this.user.org_id === 7 && this.action === 'create') {
      this.item.api_keys = ['bee095f2-1525-477f-bc90-640a3e41a8de', 'asa095f2-1525-477f-aw80-640a3e41a8de']
    }
  },
  methods: {
    togglePasswordChange() {
      this.passwordChangeActive = !this.passwordChangeActive
    },
    validateAnchor(text) {
      return /^[a-zA-Z0-9!@#$%^&*()_+[\]{};':"\\|,.<>?-]*$/.test(text)
    },
    setSignaturesCollapsed(id) {
      return this.signatures.collapsed[id]
    },
    setParentTag(tag) {
      this.countryParentTag = tag
    },
    setLastUser() {
      let date = new Date()
      let lastEdited = this.item.contents.additionals.last_edited_user
      if (lastEdited && lastEdited.length > 9) {
        lastEdited.pop()
      }
      this.item.contents.additionals.last_edited_user.unshift({ name: this.user.name, date: date })
    },
    actionStatus() {
      return this.action
    },
    closeRevisions() {
      this.revisions.active = false
      this.revisions.selected = null
    },
    async fetchDeeplTranslation(sourceLanguage) {
      this.loading = true
      const source = this.l10n[sourceLanguage.toLowerCase()]
      let target = JSON.parse(JSON.stringify(source))

      let outputLang = this.lang

      if (outputLang === 'pt') {
        outputLang = 'pt-br'
      } else if (outputLang === 'no') {
        outputLang = 'nb'
      }

      const translateField = async (text) => {
        try {
          const response = await fetch('https://translationspsi.com/translate', {
            method: 'POST',
            headers: {
              Host: 'api.deepl.com',
              Authorization: 'DeepL-Auth-Key d81e6d2f-afa9-b34a-cdb4-bc5fb35ec079',
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `source_lang=${sourceLanguage.toUpperCase()}&text=${encodeURIComponent(
              text
            )}&target_lang=${outputLang.toUpperCase()}&tag_handling=html`,
          })
          const data = await response.json()
          return data.translations[0].text
        } catch (error) {
          this.loading = false
          console.log(error)
        }
      }

      const staticFields = ['title', 'subtitle', 'description', 'foreword']
      const translationFieldsPromises = staticFields.map(async (field) => {
        if (target[field]?.length > 0) {
          target[field] = await translateField(target[field])
        }
      })

      await Promise.all(translationFieldsPromises)

      console.log(target.contents)

      const translateBlock = async (blocks) => {
        await Promise.all(
          blocks.map(async (block) => {
            console.log(block)
            for (const key in block) {
              if (typeof block[key] === 'string' && !['name', 'type'].includes(key)) {
                if (block[key]?.length > 0) block[key] = await translateField(block[key])
              } else if (typeof block[key] === 'object') {
                for (const subKey in block[key]) {
                  if (typeof block[key][subKey] === 'string') {
                    if (block[key][subKey]?.length > 0) block[key][subKey] = await translateField(block[key][subKey])
                  } else if (Array.isArray(block[key][subKey])) {
                    await translateBlock(block[key][subKey])
                  } else if (typeof block[key][subKey] === 'object' && key === 'accordions') {
                    await translateBlock(block[key])
                  }
                }
              }
            }
          })
        )
      }

      await translateBlock(target.contents)
      this.loading = false

      const translation = this.item.l10n.find((l10n) => l10n.lang === this.lang)
      staticFields.forEach((field) => {
        translation[field] = target[field]
      })

      translation.contents = target.contents
    },
    getRevisions() {
      this.revisions.active = true
      this.revisions.loading = true
      HTTP.get(`resource/revisions/${this.item.id}`)
        .then((result) => {
          this.revisions.loading = false
          this.revisions.data = result.data
        })
        .catch((err) => {
          this.revisions.loading = false
          this.revisions.error = err
        })
    },
    useRevision() {
      if (
        confirm(
          'This will overwrite the current post on the left with the selected revision on your right. Are you sure you with to proceed?'
        )
      ) {
        let lastEditData = this.item.contents.additionals.last_edited_user
        const revision = JSON.parse(JSON.stringify(this.revisions.selected))
        delete revision.id
        revision.contents.additionals.last_edited_user = lastEditData

        this.item = { ...this.item, ...revision }
        this.transformTranslationData(this.item.l10n)

        this.revisions.active = false
      }
    },
    filterRevisionObject(item) {
      return Object.keys(item)
        .filter((k) => ['end_datetime', 'l10n', 'start_datetime'].includes(k))
        .reduce((obj, key) => {
          obj[key] = item[key]
          return obj
        }, {})
    },
    getSubscribersList() {
      this.subscribers.active = true
      HTTP.post(`/search/subscriber`, {
        tags: [this.item.tags.find((tag) => tag.type === 'campaign').id],
        status: 'subscribed',
      })
        .then((response) => {
          this.subscribers.list = response.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    closeSubscribersList() {
      this.subscribers.active = false
    },
    getSubscribersCSV() {
      HTTP.post(`/search/subscribers_csv`, {
        tags: [this.item.tags.find((tag) => tag.type === 'campaign').id],
        status: 'subscribed',
      })
        .then((response) => {
          console.log(response)
          let fileContent = 'data:text/csv;charset=utf-8,'
          fileContent += response.data
          const encodedUri = encodeURI(fileContent)
          window.open(encodedUri)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    copyBlocks(translation, field) {
      if (confirm(`Are you sure you with to overwrite this content with content from ${translation}?`))
        this.l10n[this.lang][field] = JSON.parse(JSON.stringify(this.l10n[translation.toLowerCase()][field]))
    },
    formatBlockTitle(title) {
      // Dumb way of renaming the repository block
      if (title.toLowerCase() === 'repository') title = 'Attachments'
      return this.capitalize(title.replace(/_/g, ' '))
    },
    // Types
    addWebsiteBlock(block, websiteBlocks) {
      if (block.name === 'grid') {
        const fields = block.contents.grid.fields
        const blocks = block.contents.grid.blocks

        if (fields.length > blocks.length) {
          fields.forEach((item) => {
            blocks.push(websiteBlocks.find((block) => block.name === item))
          })
        }
      }
      this.l10n[this.lang].contents.push(block)
    },
    addText() {
      this.l10n[this.lang].contents.push({ type: 'text', text: '' })
    },
    addAccordion() {
      this.l10n[this.lang].contents.push({
        type: 'accordion',
        accordions: [{ title: '', content: '' }],
      })
    },
    addAccordionItem(block) {
      block.accordions.push({ title: '', content: '' })
    },
    addAccordionItemRepo(block) {
      block.accordions.push({ type: 'resource', title: '', ids: [] })
    },
    removeAccordionItem(block, index) {
      if (confirm('Are you sure you with to remove this custom field?')) block.accordions.splice(index, 1)
    },
    addRepo() {
      alert('If you want this repository to be private please password protect the whole resource first.')
      this.l10n[this.lang].contents.push({ type: 'repository', files: [] })
    },
    addRelatedResources() {
      this.l10n[this.lang].contents.push({
        title: '',
        limit: 1,
        type: 'related_resources',
        types: [],
        tag_ids: [],
      })
    },
    addVideo() {
      this.l10n[this.lang].contents.push({ type: 'video', id: '' })
    },
    addImage() {
      this.l10n[this.lang].contents.push({
        type: 'image',
        caption: '',
        alt: '',
        thumbnail_urls: {},
      })
    },
    addImageQuote() {
      this.l10n[this.lang].contents.push({
        type: 'quote',
        text: '',
        source: '',
        thumbnail_urls: {},
      })
    },
    addResource() {
      this.l10n[this.lang].contents.push({ type: 'resources', title: '', ids: [] })
    },
    addQuizEmbed() {
      this.l10n[this.lang].contents.push({
        type: 'quiz_embed',
        id: [],
      })
    },
    addPetition() {
      this.l10n[this.lang].contents.push({
        type: 'cta_petition',
        title: '',
        label: '',
        result: '',
        params: { name: 'Petition name', contents: {} },
      })
    },
    addEvent() {
      this.l10n[this.lang].contents.push({
        type: 'cta_event',
        title: '',
        label: '',
        result: '',
        params: { name: '', contents: { event_id: '' } },
      })
    },

    addVideoask() {
      this.l10n[this.lang].contents.push({
        type: 'cta_videoask',
        title: '',
        url: '',
      })
    },

    addAnchor() {
      this.l10n[this.lang].contents.push({
        type: 'anchor_link',
        url: '',
        title: 'anchor',
      })
    },

    // Custom field builder
    addCustomField(type, fields = this.l10n[this.lang].custom_fields) {
      if (type === 'string') fields.push({ name: '', group: '', type: 'string', text: '' })
      if (type === 'text') fields.push({ name: '', group: '', type: 'text', text: '' })
      if (type === 'repeater') fields.push({ name: '', group: '', type: 'repeater', contents: [], length: 1 })
      if (type === 'tags') fields.push({ name: '', group: '', type: 'tags', tags: [], tag_ids: [] })
      if (type === 'author') fields.push({ name: '', group: '', type: 'author', authors: [] })
      if (type === 'image') fields.push({ name: '', group: '', type: 'image', images: [] })
      if (type === 'resource') fields.push({ name: '', group: '', type: 'resource', resource_id: null })
    },
    removeCustomField(index, fields = this.l10n[this.lang].custom_fields) {
      if (confirm('Are you sure you with to remove this custom field?')) fields.splice(index, 1)
    },
    openFieldSettings(index) {
      if (this.fieldSettings !== index) {
        this.fieldSettings = index
      } else {
        this.fieldSettings = null
      }
    },

    // Block options
    showSignatures(id) {
      this.signatures.loading = true
      HTTP.get(`org/${this.org.id}/petition/${id}/signatures`).then((response) => {
        this.signatures.loading = false
        this.$set(this.signatures, id, response.data)
        this.$set(this.signatures.collapsed, id, false)
      })
    },
    exportSignatures(id, type) {
      HTTP.get(`org/${this.org.id}/petition/${id}/signatures_${type}`).then((response) => {
        const encodedCsvContent = encodeURIComponent(response.data)
        const encodedUri = `data:text/csv;charset=utf-8,${encodedCsvContent}`
        window.open(encodedUri)
      })
    },

    // Actions
    removeBlock(index) {
      if (confirm('Are you sure you wish to remove this block?')) this.l10n[this.lang].contents.splice(index, 1)
    },

    moveAccordionBlock(index, direction, accordions) {
      const newIndex = direction === 'up' ? index - 1 : index + 1

      if (newIndex >= 0 && newIndex < accordions.length) {
        const temp = accordions[index]
        this.$set(accordions, index, accordions[newIndex])
        this.$set(accordions, newIndex, temp)
      }
    },
    duplicateBlock(index) {
      const item = JSON.parse(JSON.stringify(this.l10n[this.lang].contents[index]))
      if (confirm('This will place an exact duplicate of this block below the current one. Proceed?'))
        this.l10n[this.lang].contents.splice(index, 0, item)
      this.activeIndex = index + 1
    },
    moveBlock(indexA, indexB, arr = this.l10n[this.lang].contents) {
      // Geneartes a blockID for :key reference. Without an exact key moving stuff won't work!
      this.$set(this.l10n[this.lang].contents[indexA], 'blockID', this.randomify())
      this.$set(this.l10n[this.lang].contents[indexB], 'blockID', this.randomify())

      this.activeIndex = null
      this.activeIndex = indexB
      arr.splice(indexB, 0, arr.splice(indexA, 1)[0])
    },
    movePrompt(indexA) {
      const indexB = prompt(
        'Move the item by specifying an ordinal number (e.g. 1 will place the item first)',
        indexA + 1
      )
      if (indexB > this.l10n[this.lang].contents.length) {
        alert(`Index can't be larger than ${this.l10n[this.lang].contents.length}`)
        this.movePrompt(indexA)
      }
      if (indexB === null) return

      this.moveBlock(indexA, indexB - 1)
    },

    // Location
    setPlace(place) {
      this.l10n[this.lang].location_info = place.formatted_address
      this.item.contents.location = {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
      }
    },

    // Clone method
    clone() {
      if (confirm('Are you sure you with to clone this resource?')) this.update('resource', true)
      return false
    },

    chooseImage(image) {
      const url = `https://pop-umbrella.s3.amazonaws.com/static/images/library/library_image_${image}.jpg`
      const sizes = ['card', 'event', 'featured', 'large', 'original', 'publication_cover']
      this.item.contents.thumbnail_url = url
      if (this.item.contents.thumbnail_urls.length === 0) this.$set(this.item.contents, 'thumbnail_urls', {})
      sizes.forEach((size) => {
        this.$set(this.item.contents.thumbnail_urls, size, url)
      })
      this.library = false
    },

    updateResources(block, $event, prop = 'resources') {
      block[prop] = $event
    },
  },
}
</script>
